import {
  HashRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";

import UserMaster from "../containers/UserMaster";
import Dashboard from "../containers/Dashboard";
import Login from "../containers/Login";
import RoleMaster from "../containers/RoleMaster";
import RoleVsCapabilityTwo from "../containers/RoleVsCapabilityTwo";
import Questions from "../containers/Questions";
import SystemSettings from "../containers/SystemSettings";
import DownloadQuestionsandAnswers from "../containers/DownloadQuestionsandAnswers";
import AnswerQuestions from "../containers/AnswerQuestions";
import DownloadAttachments from "../containers/DownloadAttachments";
import { useEffect, useRef, useState } from "react";
import { authenticationAPI, BindAPI, IUDAPI, LoginAPI } from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";

import Payment from "../containers/Payment";
import DownloadQuestionsandAnswersAnalyst from "../containers/DownloadQuestionsandAnswersAnalyst";
import DownloadAttachmentsAnalyst from "../containers/DownloadAttachmentsAnalyst";
import PartnerMaping from "../containers/PartnerMaping";
import Module from "../containers/Module";
import AssessmentReport from "../containers/AssessmentReport";
import Topic from "../containers/Topic";
import PartnerMaster from "../containers/PartnerMaster";
import Landingpage from "../containers/Landingpage";
import Page2 from "../Landingpage-2/Page2";
import AnswerSubmission from "../containers/AnswerSubmission";
import CompanyPartnerMapping from "../Reports/CompanyPartnerMapping";
import AssessmentReport1 from "../Reports/AssessmentReport";
import DownloadQuestions from "../containers/DownloadQuestions";
import AssessmentReportPartner from "../containers/AssessmentReportPartner";
import DocumentRepository from "../containers/DocumentRepository";
import WhyEthosflo from "../Landingpage-2/Whyethosflo";
import HowItWorks from  "../Landingpage-2/Howitworks";
import HelpfulResources from "../Landingpage-2/Helpfulresources";
import DataPrivacy from "../Landingpage-2/Dataprivacy";
import Frequentlyaskedquestions from "../Landingpage-2/Frequentlyaskedquestions";

import  AssessmentModules from "../Landingpage-2/Assessmentmodules";
import Footer from "../Landingpage-2/Footer";

const RootRouter = () => {
  const { userProfileState, dispatch } = useUserCapability();
  const [tableSdpData, setTableSdpData] = useState([]);
  const [idleTimeInSeconds, setIdleTimeInSeconds] = useState(300);
  const idleTimer = useRef(null);
  const activityInterval = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const sessionToken = useRef(`${Date.now()}_${Math.random()}`);

  const systemSettingsData = async () => {
    try {
      const { data } = await BindAPI("SystemSettingsAPI/BindSystemSettings");
      if (data?.Table?.[0]?.SessionTimeInSeconds) {
        setIdleTimeInSeconds(data.Table[0].SessionTimeInSeconds);
      }
    } catch (error) {
      console.error("Failed to fetch system settings", error);
    }
  };

  const logoutUser = async () => {
    clearInterval(activityInterval.current);
    const createdBy = sessionStorage.getItem("createdBy");

    if (createdBy) {
      const data = {
        sessionId: 0,
        mstUserId: Number(createdBy),
        lastActivity: new Date().toISOString(),
        isActive: 0,
        flag: 1,
      };

      try {
        await LoginAPI(data, "Login/Login");
      } catch (error) {
        console.error("Logout API Error", error);
      }

      localStorage.removeItem(`user_session_${createdBy}`);
    }

    sessionStorage.clear();
    localStorage.clear();
    navigate("/login");
  };

  const handleTabClose = () => {
    const isReload = window.performance?.getEntriesByType("navigation")[0]?.type === "reload";
    if (!isReload) {
      const createdBy = sessionStorage.getItem("createdBy");
      if (createdBy) {
        const data = [{ mstUserId: createdBy, status: 0 }];
        navigator.sendBeacon("UserAPI/IUDLogin", JSON.stringify(data));
        localStorage.removeItem(`user_session_${createdBy}`);
      }

      sessionStorage.clear();
      localStorage.clear();
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleTabClose);
    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  const updateActivity = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
    if (!createdBy) return;

    const data = {
      sessionId: 0,
      mstUserId: Number(createdBy),
      lastActivity: new Date().toISOString(),
      isActive: 1,
      flag: 1,
    };

    try {
      await LoginAPI(data, "Login/Login");
    } catch (error) {
      console.error("Activity Update Error", error);
    }
  };

  useEffect(() => {
    if (location.pathname === '/login') return;

    activityInterval.current = setInterval(updateActivity, 60000);
    return () => clearInterval(activityInterval.current);
  }, [location.pathname]);

  const resetIdleTimer = () => {
    if (idleTimer.current) clearTimeout(idleTimer.current);
    idleTimer.current = setTimeout(logoutUser, idleTimeInSeconds * 1000);
  };

  const refreshUserData = async () => {
    const userName = sessionStorage.getItem("userName");
    const password = sessionStorage.getItem("password");
    const AllSDP = sessionStorage.getItem("AllSDP") || "";
    const AllSDPArray = AllSDP.split(",").map((item) => parseInt(item.trim(), 10));

    if (!userName || !password) {
      console.error("Missing credentials");
      return;
    }

    try {
      const { data } = await authenticationAPI(
        { userName, password },
        "LoginAPI/LoginValid"
      );

      if (data?.jsonString) {
        const tableDatas = JSON.parse(data.jsonString);

        if (["S", "LS"].includes(tableDatas.Table?.[0]?.Result)) {
          const userProfile = tableDatas.Table1 ?? [];
          const userVsCapability = tableDatas.Table2 ?? [];

          if (userProfile.length) {
            const updatedProfile = userProfile.map((item) => ({
              ...item,
              AllSDP: AllSDPArray,
            }));

            const createdBy = updatedProfile[0]?.MstUserId;

            sessionStorage.setItem("createdBy", createdBy);
            localStorage.setItem(`user_session_${createdBy}`, sessionToken.current);

            setTableSdpData(updatedProfile);
            dispatch({ type: "USER_PROFILE", payload: updatedProfile });
          } else {
            console.log("User not found");
          }

          dispatch({ type: "USER_VS_CAPABILITY", payload: userVsCapability });
          localStorage.setItem("jwtToken", data.token);
        }
      }
    } catch (error) {
      console.error("Refresh Login Error", error);
    }
  };

  useEffect(() => {
    if (location.pathname === '/') return;

    const events = [
      "mousemove",
      "keydown",
      "scroll",
      "click",
      "touchstart",
      "touchmove",
    ];

    events.forEach((event) => window.addEventListener(event, resetIdleTimer));
    resetIdleTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
      if (idleTimer.current) clearTimeout(idleTimer.current);
    };
  }, [idleTimeInSeconds, location.pathname]);

  useEffect(() => {
    const initialize = async () => {
      await systemSettingsData();

      const userId = sessionStorage.getItem("createdBy");
      if (userId) {
        await refreshUserData();
      }
    };

    initialize();
  }, []);

  useEffect(() => {
    const createdBy = sessionStorage.getItem("createdBy");
    if (!createdBy) return;

    const handleStorageChange = (e) => {
      if (e.key === `user_session_${createdBy}`) {
        const latestToken = localStorage.getItem(`user_session_${createdBy}`);
        if (sessionToken.current !== latestToken) {
          console.warn("Duplicate tab login detected. Logging out...");
          logoutUser();
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/login" element={<Login />} />
      <Route path="/usermaster" element={<UserMaster />} />
      <Route path="/partnermaster" element={<PartnerMaster />} />
      <Route path="/rolemaster" element={<RoleMaster />} />
      <Route path="/rolevscapability" element={<RoleVsCapabilityTwo />} />
      <Route path="/questions" element={<Questions />} />
      <Route path="/systemsettings" element={<SystemSettings />} />
      <Route path="/downloadquestionsandanswers" element={<DownloadQuestionsandAnswers />} />
      <Route path="/answerquestions" element={<AnswerQuestions />} />
      <Route path="/downloadattachments" element={<DownloadAttachments />} />
      <Route path="/paymentinfo" element={<Payment />} />
      <Route path="/assessmentreport" element={<AssessmentReport />} />
      <Route path="/downloadquestionsandanswersanalyst" element={<DownloadQuestionsandAnswersAnalyst />} />
      <Route path="/downloadattachmentsanalyst" element={<DownloadAttachmentsAnalyst />} />
      <Route path="/partnermaping" element={<PartnerMaping />} />
      <Route path="/topic" element={<Topic />} />
      <Route path="/" element={<Page2 />} />
      <Route path="/whyethosflo" element={<WhyEthosflo />} />
      <Route path="/assessmentmodules" element={<AssessmentModules />} />
      <Route path="/howitworks" element={<HowItWorks />} />
      <Route path="/helpfulresources" element={<HelpfulResources />} />
      <Route path="/dataprivacy" element={<DataPrivacy />} />
      <Route path="/frequentlyaskedquestions" element={<Frequentlyaskedquestions />} />
    
      <Route path="/contactus" element={<Footer />} />

      <Route path="/module" element={<Module />} />
      <Route path="/answersubmission" element={<AnswerSubmission />} />
      <Route path="/companypartnermapping" element={<CompanyPartnerMapping />} />
      <Route path="/assessmentreport1" element={<AssessmentReport1 />} />
      <Route path="/downloadquestions" element={<DownloadQuestions />} />
      <Route path="/partnerassessmentreport" element={<AssessmentReportPartner />} />
      <Route path="/documentrepository" element={<DocumentRepository />} />

    </Routes>
  );
};

export default RootRouter;
